import { CSSProperties } from 'react';
import { ChipProps } from '@mui/material';
import { error, info, secondary, success } from 'assets/colors/colors';

export const getChipStyles: Record<
  Exclude<ChipProps['color'], undefined>,
  CSSProperties
> = {
  success: {
    backgroundColor: success.background,
    color: success.main,
  },
  warning: {
    backgroundColor: secondary.background,
    color: secondary.main,
  },
  error: {
    backgroundColor: error.background,
    color: error.main,
  },
  default: {},
  info: {
    backgroundColor: info.background,
    color: info.main,
  },
  primary: {},
  secondary: {},
};
